import { ref } from 'vue';
import { config } from './config';

/**
 * Version globale des avatars — bumpée après un téléversement/retrait pour
 * forcer les <img> à recharger (l'URL est stable par utilisateur).
 */
export const avatarVersion = ref(0);

export function bumpAvatarVersion(): void {
  avatarVersion.value += 1;
}

/** URL publique de la photo/mascotte d'un collaborateur (picto). */
export function avatarSrc(userId: string): string {
  const v = avatarVersion.value;
  return `${config.API_BASE_URL}/users/${userId}/avatar${v ? `?v=${v}` : ''}`;
}

/**
 * URL de la photo d'un collaborateur de l'ANNUAIRE, qui n'a pas encore de
 * compte (0046). La clé est une empreinte de l'adresse, calculée par l'API :
 * l'écran ne fait que la relayer, aucune adresse ne circule dans l'URL.
 */
export function annuaireAvatarSrc(key: string): string {
  const v = avatarVersion.value;
  return `${config.API_BASE_URL}/annuaire/avatars/${key}${v ? `?v=${v}` : ''}`;
}
